import { getConfig } from "../../../../config/app";

const basePath = getConfig("basePath");
const path = basePath === "/" ? "" : basePath;

export const getQuoteURL = (formId: string) => `${path}/seguro-automotriz/form/${formId}/quote`;
export const getQuoteBackToOfferURL = (formId: string) =>
  `${path}/seguro-automotriz/results/${formId}`;
